import { render, staticRenderFns } from "./TyreSpecField.vue?vue&type=template&id=a6e6c51a"
import script from "./TyreSpecField.vue?vue&type=script&lang=ts"
export * from "./TyreSpecField.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports